import requestWrapper from '../../requestWrapper';
import endpoints from './endpoints';
import type {Album} from '@deezer/next/services/types/album';
import type {Track} from '@deezer/next/services/types/track';

const {get} = requestWrapper;

const requests = {
	get: (upc: string) => get<Album>(endpoints.albumByUPC(upc)),
	getTracks: (upc: string) =>
		get<{[albumKey: string]: {[trackKey: string]: Track}}>(
			endpoints.albumTracks(upc),
		),
};

export default requests;
